<template>
  <BareFullScreenPopup
    ref="popup"
    :closeable="true"
    @visibility-change="onVisibilityChange"
  >
    <div class="policy-success-popup">
      <p class="policy-success-popup__title">Ваш поліс успішно укладений</p>
      <p v-if="policyLink" class="policy-success-popup__text">Перевірити його можна за посиланням нижче</p>
      <p v-else-if="policyCode" class="policy-success-popup__text">Номер угоди: {{ policyCode }}</p>
      <div class="policy-success-popup__link-row">
        <InsuranceCompanyLogo
          v-if="policyLink"
          :logo="companyLogo"
          :alternative-text="companyName"
        />
        <CopyInput
          v-if="policyLink"
          :value="policyLink"
          class="policy-success-popup__link-input"
          placeholder="Посилання на перевірку полісу"
        />
      </div>
      <div class="policy-success-popup__actions" :style="policyLink ? 'display: flex; gap: 12px;' : ''">
        <a
          v-if="policyLink"
          :href="policyLink"
          target="_blank"
          download
          class="policy-success-popup__btn btn btn-primary"
          style="display: inline-flex; align-items: center; justify-content: center; text-decoration: none; padding: 10px 16px; border-radius: 8px;"
        >
          Завантажити поліс
        </a>
        <BlueButton class="policy-success-popup__btn" @click="close">Закрити</BlueButton>
      </div>
    </div>
  </BareFullScreenPopup>
</template>

<script>
import { BlueButton, CopyInput } from '@/shared/ui/form';
import { InsuranceCompanyLogo } from '@/shared/ui/insurance';
import { BareFullScreenPopup } from '@/shared/ui/popup';

export default {
  name: 'PolicySuccessPopup',
  components: { BareFullScreenPopup, BlueButton, CopyInput, InsuranceCompanyLogo },
  data() {
    return {
      policyLink: null,
      policyCode: '',
      companyLogo: '',
      companyName: '',
    };
  },
  methods: {
    open(policyLink, companyLogo, companyName, policyCode = '') {
      this.policyLink = policyLink || null;
      this.policyCode = policyCode || '';
      this.companyLogo = companyLogo || '';
      this.companyName = companyName || '';

      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },
    close() {
      this.$refs.popup?.close();
    },
    onVisibilityChange({ isVisible }) {
      if (!isVisible) {
        this.$emit('closed');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.policy-success-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;

  &__title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__text {
    font-size: 16px;
    font-weight: 500;
    color: #717680;
    text-align: center;
    margin-bottom: 24px;
  }

  &__link-row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    max-width: 400px;
    margin-bottom: 24px;
  }

  &__link-input {
    flex: 1;
  }

  &__actions {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  &__btn {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .fullscreen-popup__content-wrapper {
  max-width: 500px;
}

::v-deep .company-logo,
::v-deep .company-logo__placeholder {
  max-height: 50px;
  max-width: 50px;
  margin-right: 0;
}
</style>
